export default "__VITE_PUBLIC_ASSET__9222f650__"